export class ViewedVideos {
    constructor() {
        this.apiUrl = window.testimonialData.testimonialsById;
    };
    
    checkViewed(initial = false) {
        if (localStorage.getItem('Videos')) {
            const viewedVideos = JSON.parse(localStorage.getItem('Videos'));
            
            $('.user-story-container').each((index, element) => {
                const userId = $(element).data('user-id');
                const found = viewedVideos[userId];

                if (found) {
                    if (found.allViewed) {
                        $(element).removeClass('new');
                    } else {
                        $(element).addClass('new');
                    }
                } else {
                    $(element).addClass('new');
                }
            });

            let newItems = [];
            let oldItems = [];
            let length = $('.user-story-container').length;
            
            for(let i=0; i < length; i++) {
        
                let storyObj = {};
                storyObj.newer = $('.user-story-container').eq(i).data('order');
                storyObj.data = $('.user-story-container').eq(i).data('user-id');
                storyObj.avatar = $('.user-story-container').eq(i).find('img').attr('src');
                storyObj.name = $('.user-story-container').eq(i).find('.user-story-name').text();
                storyObj.classes = $('.user-story-container').eq(i).attr('class');
                
                if (storyObj.classes.includes("new")) {
                    newItems.push(storyObj);
                } else {
                    oldItems.push(storyObj);
                }
            }

            newItems.sort(function(a, b) {
                return a.newer - b.newer;
            });

            oldItems.sort(function(a, b) {
                return a.newer - b.newer;
            });

            let allStories = newItems.concat(oldItems);

            if (initial) {
                $('.testimonial-stories .user-story-container').remove();

                allStories.forEach((current, index) => {
                    $('.testimonial-stories').append(`
                    <div class="${current.classes}" data-user-id="${current.data}" data-order="${current.newer}">
                        <div class="user-story"><img src="${current.avatar}" /></div>
                        <div class="user-story-name">${current.name}</div>
                    </div>
                    `)
                });
            } else {
                $('.testimonial-stories .slick-track').empty();

                allStories.forEach((current, index) => {
                    $('.testimonial-stories .slick-track').append(`
                    <div class="${current.classes}" data-user-id="${current.data}" data-order="${current.newer}">
                        <div class="user-story"><img src="${current.avatar}" /></div>
                        <div class="user-story-name">${current.name}</div>
                    </div>
                    `)
                });
            }
        } else {
            $('.user-story-container').each((index, element) => {
                $(element).addClass('new');
            });
        }
    };

    addToLocalStorage() {
        if (localStorage.getItem('Videos')) {
            let viewedTestimonials = JSON.parse(localStorage.getItem('Videos'));

            $('.user-story-container').each((index, element) => {
                const userId = $(element).data("user-id");
                const found = viewedTestimonials[userId];

                if (!found) {
                    this.fetchTestimonial(userId).then((data) => {
                        let viewedVideos = JSON.parse(localStorage.getItem('Videos'));
                        let array = data.data.testimonials.reduce((acc, current) => 
                            acc = [...acc, current.id]
                        , []);
                        array.sort();

                        viewedVideos = {
                            ...viewedVideos,
                            [userId]: {
                                userId: userId,
                                allViewed: false,
                                allVideos: array,
                                videosViewed: []
                            }
                        };

                        localStorage.setItem('Videos', JSON.stringify(viewedVideos));
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                    this.fetchTestimonial(userId).then((data) => {
                        let viewedVideos = JSON.parse(localStorage.getItem('Videos'));
                        let array = data.data.testimonials.reduce((acc, current) => 
                            acc = [...acc, current.id]
                        , []);
                        array.sort();

                        let temp = {
                            ...viewedVideos,
                            [userId]: {
                                userId: userId,
                                allViewed: this.areEqual(array, viewedVideos[userId].videosViewed) ? true : this.areEqual(array, array.filter(value => viewedVideos[userId].videosViewed.includes(value))) ? true : false,
                                allVideos: array,
                                videosViewed: this.areEqual(array, viewedVideos[userId].videosViewed) ? array : array.filter(value => viewedVideos[userId].videosViewed.includes(value))
                            }
                        };

                        localStorage.setItem('Videos', JSON.stringify(temp));
                    }).catch(error => {
                        console.log(error);
                    });
                }
            });
        }
    };

    async fetchTestimonial(userId) {
        const axiosOptions = {
            params: {
                userId: userId
            }
        };

        try {
            const response = await axios.get(this.apiUrl, axiosOptions);

            return await response.data;
        } catch (error) {
            console.log(error);
        }
    };

    areEqual(first, second) {
        if (!Array.isArray(first) || !Array.isArray(second)) {
            return false;
        };

        if(first.length !== second.length){
           return false;
        };

        for(let i = 0; i < first.length; i++){
           if(!second.includes(first[i])){
              return false;
           };
        };

        return true;
    };
};